// src/components/admin/TeamProfileSettingsEditor.js
import React, { useState } from 'react';

const TeamProfileSettingsEditor = ({ 
    appTitle, setAppTitle,
    faviconUrl, setFaviconUrl,
    topBannerUrl, setTopBannerUrl,
    teamEmblemUrl, setTeamEmblemUrl,
    teamPhotoUrl, setTeamPhotoUrl,
    leagueName, setLeagueName,
    operatingCompany, setOperatingCompany,
    teamIntro, setTeamIntro,
    establishedDate, setEstablishedDate,
    homeGround, setHomeGround,
    snsLinks, setSnsLinks,
    requireApproval, setRequireApproval,
    showMemberList, setShowMemberList,
    // LINE用トークン
    lineNotifyToken, setLineNotifyToken
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const updateSns = (key, value) => {
        setSnsLinks(prev => ({ ...prev, [key]: value }));
    };

    // アイコン風スタイルの定義
    const iconStyle = (bg, color = 'white') => ({
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: '32px', height: '32px', borderRadius: '50%',
        background: bg, color: color, fontSize: '14px', fontWeight: 'bold', flexShrink: 0
    });

    return (
        <div style={{marginBottom:'20px', border:'1px solid #ddd', borderRadius:'8px', background:'white', overflow:'hidden'}}>
            <div 
                onClick={() => setIsOpen(!isOpen)} 
                style={{
                    padding:'15px', background:'#f5f5f5', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', fontWeight:'bold'
                }}
            >
                <span>👕 チームプロフィール・設定</span>
                <span>{isOpen ? '▲ 閉じる' : '▼ 開く'}</span>
            </div>
            
            {isOpen && (
                <div style={{padding:'15px'}}>
                    {/* --- 基本機能のオン/オフ --- */}
                    <div style={{marginBottom:'20px', padding:'10px', background:'#fff3e0', borderRadius:'8px', border:'1px solid #ffe0b2'}}>
                        <h4 style={{margin:'0 0 10px 0', color:'#e65100', fontSize:'14px'}}>⚙️ 基本機能のオン/オフ</h4>
                        <label style={{fontSize:'12px', display:'flex', alignItems:'center', cursor:'pointer', marginBottom:'10px'}}>
                            <input type="checkbox" checked={requireApproval} onChange={e=>setRequireApproval(e.target.checked)} style={{width:'auto', marginRight:'8px'}} />
                            新規登録を「承認制」にする (OFFなら即利用可)
                        </label>
                        <label style={{fontSize:'12px', display:'flex', alignItems:'center', cursor:'pointer'}}>
                            <input type="checkbox" checked={showMemberList} onChange={e=>setShowMemberList(e.target.checked)} style={{width:'auto', marginRight:'8px'}} />
                            チームタブに「メンバー一覧」を表示する
                        </label>
                    </div>

                    {/* --- LINE Messaging API設定 --- */}
                    <div style={{marginBottom:'20px', padding:'10px', background:'#f1f8e9', borderRadius:'8px', border:'1px solid #c5e1a5'}}>
                        <h4 style={{margin:'0 0 5px 0', color:'#558b2f', fontSize:'14px'}}>🔔 LINE Messaging API設定</h4>
                        <div style={{fontSize:'10px', color:'#666', marginBottom:'8px'}}>
                            LINE公式アカウントを使って通知を送ります。<br/>
                            1. <a href="https://developers.line.biz/" target="_blank" rel="noopener noreferrer" style={{color:'#2e7d32'}}>LINE Developers</a>でチャネル作成・設定<br/>
                            2. 「Messaging API設定」でアクセストークン(長期)を発行<br/>
                            3. 公式アカウント(ボット)をLINEグループに招待する<br/>
                            4. <b>グループID</b>を入力（※ID取得方法はデプロイ後に確認）
                        </div>
                        
                        <div style={{marginBottom:'10px'}}>
                            <label style={{fontSize:'10px', fontWeight:'bold', display:'block', marginBottom:'2px'}}>チャネルアクセストークン (長期)</label>
                            <input 
                                type="password" 
                                value={lineNotifyToken || ''} 
                                onChange={e=>setLineNotifyToken(e.target.value)} 
                                placeholder="長い文字列..." 
                                style={{width:'100%', padding:'8px', borderRadius:'4px', border:'1px solid #ccc', background:'white'}}
                            />
                        </div>

                        <div>
                            <label style={{fontSize:'10px', fontWeight:'bold', display:'block', marginBottom:'2px'}}>送信先グループID (C... または U...)</label>
                            <input 
                                type="text" 
                                value={snsLinks.lineGroupId || ''} 
                                onChange={e=>updateSns('lineGroupId', e.target.value)} 
                                placeholder="Cxxxxxxxxxxxxxxxx..." 
                                style={{width:'100%', padding:'8px', borderRadius:'4px', border:'1px solid #ccc', background:'white'}}
                            />
                        </div>
                    </div>

                    <div style={{marginBottom:'15px'}}>
                        <label style={{fontSize:'12px', fontWeight:'bold', display:'block', marginBottom:'5px'}}>チーム名 (アプリタイトル)</label>
                        <input type="text" value={appTitle} onChange={e=>setAppTitle(e.target.value)} placeholder="Revengers FC" style={{width:'100%', padding:'8px', fontSize:'16px'}} />
                    </div>

                    <div style={{marginBottom:'15px', background:'#f9f9f9', padding:'10px', borderRadius:'8px'}}>
                        <h4 style={{marginTop:0, marginBottom:'10px', fontSize:'12px', color:'#666'}}>🖼️ 画像設定 (URLを入力)</h4>
                        
                        <div style={{marginBottom:'10px'}}>
                            <label style={{fontSize:'10px', display:'block'}}>トップバナー画像 <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 1200x400px / 3:1)</span></label>
                            <input type="text" value={topBannerUrl} onChange={e=>setTopBannerUrl(e.target.value)} placeholder="https://.../banner.jpg" style={{width:'100%'}} />
                            <div style={{fontSize:'9px', color:'#999'}}>※空欄の場合、チーム名のみ表示されます</div>
                        </div>

                        <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
                            <div>
                                <label style={{fontSize:'10px', display:'block'}}>チームエンブレム <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 512x512px)</span></label>
                                <input type="text" value={teamEmblemUrl} onChange={e=>setTeamEmblemUrl(e.target.value)} placeholder="https://.../logo.png" style={{width:'100%'}} />
                            </div>
                            <div>
                                <label style={{fontSize:'10px', display:'block'}}>集合写真 <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 1200x600px)</span></label>
                                <input type="text" value={teamPhotoUrl} onChange={e=>setTeamPhotoUrl(e.target.value)} placeholder="https://.../team.jpg" style={{width:'100%'}} />
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                             <label style={{fontSize:'10px', display:'block'}}>ファビコン <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 32x32px)</span></label>
                             <input type="text" value={faviconUrl} onChange={e=>setFaviconUrl(e.target.value)} placeholder="https://.../icon.png" style={{width:'100%'}} />
                        </div>
                    </div>

                    <div style={{marginBottom:'15px'}}>
                        <label style={{fontSize:'12px', fontWeight:'bold', display:'block', marginBottom:'5px'}}>📝 チーム紹介文</label>
                        <textarea value={teamIntro} onChange={e=>setTeamIntro(e.target.value)} rows="3" style={{width:'100%', padding:'8px'}} placeholder="チームの紹介文を入力..." />
                    </div>

                    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'15px'}}>
                        <div>
                            <label style={{fontSize:'10px', display:'block'}}>所属リーグ・カテゴリー</label>
                            <input type="text" value={leagueName} onChange={e=>setLeagueName(e.target.value)} style={{width:'100%'}} />
                        </div>
                        <div>
                            <label style={{fontSize:'10px', display:'block'}}>活動拠点 (ホーム)</label>
                            <input type="text" value={homeGround} onChange={e=>setHomeGround(e.target.value)} style={{width:'100%'}} />
                        </div>
                        <div>
                            <label style={{fontSize:'10px', display:'block'}}>設立日・年</label>
                            <input type="text" value={establishedDate} onChange={e=>setEstablishedDate(e.target.value)} placeholder="2024年4月" style={{width:'100%'}} />
                        </div>
                        <div>
                            <label style={{fontSize:'10px', display:'block'}}>運営会社・団体名</label>
                            <input type="text" value={operatingCompany} onChange={e=>setOperatingCompany(e.target.value)} style={{width:'100%'}} />
                        </div>
                    </div>

                    <div style={{background:'#e3f2fd', padding:'15px', borderRadius:'8px'}}>
                        <h4 style={{marginTop:0, marginBottom:'10px', fontSize:'14px', color:'#1565C0'}}>🔗 SNS・外部リンク設定</h4>
                        <div style={{display:'grid', gap:'10px'}}>
                            
                            {/* YouTube */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#FF0000')}>▶</div>
                                <input type="text" value={snsLinks.youtube || ''} onChange={e=>updateSns('youtube', e.target.value)} placeholder="YouTube URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* X (Twitter) */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#000000')}>𝕏</div>
                                <input type="text" value={snsLinks.x || ''} onChange={e=>updateSns('x', e.target.value)} placeholder="X (Twitter) URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* Instagram */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)')}>📷</div>
                                <input type="text" value={snsLinks.instagram || ''} onChange={e=>updateSns('instagram', e.target.value)} placeholder="Instagram URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* TikTok */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={{...iconStyle('#000000'), textShadow: '2px 2px 0px #25F4EE, -2px -2px 0px #FE2C55'}}>🎵</div>
                                <input type="text" value={snsLinks.tiktok || ''} onChange={e=>updateSns('tiktok', e.target.value)} placeholder="TikTok URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* Facebook */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#1877F2')}>f</div>
                                <input type="text" value={snsLinks.facebook || ''} onChange={e=>updateSns('facebook', e.target.value)} placeholder="Facebook URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* Threads */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#000000')}>@</div>
                                <input type="text" value={snsLinks.threads || ''} onChange={e=>updateSns('threads', e.target.value)} placeholder="Threads URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* Webサイト */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#333333')}>🌐</div>
                                <input type="text" value={snsLinks.web || ''} onChange={e=>updateSns('web', e.target.value)} placeholder="チーム公式サイト URL" style={{flex:1, margin:0}} />
                            </div>

                            {/* カスタム */}
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <div style={iconStyle('#2196F3')}>🔗</div>
                                <input type="text" value={snsLinks.custom || ''} onChange={e=>updateSns('custom', e.target.value)} placeholder="その他 (LINE公式など) URL" style={{flex:1, margin:0}} />
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TeamProfileSettingsEditor;